import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { showToast } from "components/ui/toast";

// Get all company orders (admin)
export const useGetCompanyOrdersAdmin = (params = {}, options = {}) =>
  useQuery({
    queryKey: ["companyOrders", "admin", params],
    queryFn: async () => {
      const res = await api.get("/admin/companyOrder", { params });
      return res.data;
    },
    staleTime: 2 * 60 * 1000,
    ...options,
  });

// Process refund (approve or direct)
export const useProcessRefund = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ orderId, refundAmount }) => {
      const res = await api.post(`/admin/companyOrder/processRefund/${orderId}`, {
        refundAmount,
      });
      return res.data;
    },
    onSuccess: () => {
      showToast("success", "Refund processed successfully");
      queryClient.invalidateQueries({ queryKey: ["companyOrders"] });
    },
    onError: (error) => {
      showToast(
        "error",
        error.response?.data?.message || "Failed to process refund"
      );
    },
  });
};

// Reject refund (admin)
export const useRejectRefund = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ orderId, rejectionReason }) => {
      const res = await api.post(`/admin/companyOrder/rejectRefund/${orderId}`, {
        rejectionReason,
      });
      return res.data;
    },
    onSuccess: () => {
      showToast("success", "Refund rejected");
      queryClient.invalidateQueries({ queryKey: ["companyOrders"] });
    },
    onError: (error) => {
      showToast(
        "error",
        error.response?.data?.message || "Failed to reject refund"
      );
    },
  });
};